import React from 'react';

const UserProfile = React.lazy(() => import('./common/UM/User/Profile'));
const UserProjects = React.lazy(() => import('./pipelines/Common/UM/User/Projects'));
const UserAllProjects = React.lazy(() => import('./pipelines/Common/UM/User/AllProjects'));
const UserProjectPage = React.lazy(() => import('./pipelines/Common/Results/ProjectPage/User'));
const UserUploadfiles = React.lazy(() => import('./pipelines/Common/UM/User/Uploadfiles'));
//const UserFiles = React.lazy(() => import('./common/UM/User/Files'));
const UserJobQueue = React.lazy(() => import('./pipelines/Common/UM/User/JobQueue'));
const AdminUsers = React.lazy(() => import('./common/UM/Admin/Users'));
const AdminFiles = React.lazy(() => import('./pipelines/Common/UM/Admin/Files'));
const AdminProjects = React.lazy(() => import('./common/UM/Admin/Projects'));
const AdminProjectPage = React.lazy(() => import('./pipelines/Common/Results/ProjectPage/Admin'));
const AdminBFILitSources = React.lazy(() => import('./pipelines/bfi/LitSources'));
const AdminMycovirusLitSources = React.lazy(() => import('./pipelines/mycovirus/LitSources'));

const BFIRequestAddition = React.lazy(() => import('./pipelines/bfi/RequestAddition.js'));
const MycovirusRequestAddition = React.lazy(() => import('./pipelines/mycovirus/RequestAddition.js'));
const ScreenWorkflow = React.lazy(() => import('./pipelines/screen/Main'));
const ScreenSRADownload = React.lazy(() => import('./pipelines/SRA/Main'));
const ScreenUploads = React.lazy(() => import('./pipelines/Common/UM/User/ScreenUploads.js'));


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const privateRoutes = [
  { path: '/user/profile', exact: true, name: 'Profile', component: UserProfile },
  { path: '/user/projectlist', exact: true, name: 'Projects', component: UserProjects },
  { path: '/user/allprojectlist', exact: true, name: 'AllProjects', component: UserAllProjects },
  { path: '/user/project', name: 'ProjectPage', component: UserProjectPage },
  { path: '/user/uploadfiles', name: 'Uploadfiles', component: UserUploadfiles },
  //{ path: '/user/files', name: 'Uploadfiles', component: UserFiles },
  { path: '/user/jobqueue', name: 'Uploadfiles', component: UserJobQueue },
  { path: '/admin/userlist', name: 'Users', component: AdminUsers },
  { path: '/admin/filelist', name: 'Files', component: AdminFiles },
  { path: '/admin/projectlist', exact: true, name: 'AdminProjects', component: AdminProjects },
  { path: '/admin/project', name: 'AdminProjectPage', component: AdminProjectPage },
  { path: '/admin/bfi/litsourcelist', name: 'AdminBFILitSources', component: AdminBFILitSources },
  { path: '/admin/mycovirus/litsourcelist', name: 'AdminBFILitSources', component: AdminMycovirusLitSources },
  { path: '/litsource/bfi/add', exact: true, name: 'add', component: BFIRequestAddition },
  { path: '/litsource/mycovirus/add', exact: true, name: 'add', component: MycovirusRequestAddition },
  { path: '/screen/workflow', exact: true, name: 'screenWorkflow', component: ScreenWorkflow },
  { path: '/screen/sra2fastq', exact: true, name: 'screenWorkflow', component: ScreenSRADownload },
  { path: '/screen/uploadfiles', exact: true, name: 'screenUpload', component: ScreenUploads },

];

export default privateRoutes;